const _excluded = ["onChange"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useRef } from 'react';
import { Controller, useWatch } from 'react-hook-form';
import { InfoIcon, MenuItem, Select, TextField, Typography, useDidUpdate } from 'seagull';
import { connectControllerToTextField } from "../../../utils/react-hook-form.utils";
import { getCustomMessageValidation } from "../../../business-logic/validators";
import styles from "./IntroductoryMessageEditor.module.scss";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const messageRules = getCustomMessageValidation('Introductory message', false);
/** This component is meant to work exclusively with `react-hook-form`.
 * It's your responsibility to provide the form field name keys (which probably correspond to the template names in some way).
 * Each template's text content (= value) is provided by the containing form. */
export default function IntroductoryMessageEditor(_ref) {
  let {
    formState,
    control,
    selectedTemplateFormFieldName,
    label = 'Introductory message templates',
    templates,
    onStartEditingReadOnlyTemplate,
    testPrefix = 'intro-message-editor'
  } = _ref;
  const selectedTemplateName = useWatch({
    control,
    name: selectedTemplateFormFieldName
  });
  const refs = useRef({});
  useDidUpdate(() => {
    var _refs$current$selecte;
    const target = (_refs$current$selecte = refs.current[selectedTemplateName]) === null || _refs$current$selecte === void 0 ? void 0 : _refs$current$selecte.querySelector('textarea');
    if (target) {
      // a hack to move the cursor to the end
      const currentValue = target.value;
      target.value = '';
      target.value = currentValue;
    }
    target === null || target === void 0 || target.focus();
  }, [selectedTemplateName]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.fieldWithTooltip,
      children: [/*#__PURE__*/_jsx(Typography, {
        children: label
      }), /*#__PURE__*/_jsx(InfoIcon, {
        info: "This message will show as an introductory message on the agreement and the email your client receives."
      })]
    }), /*#__PURE__*/_jsx(Controller, {
      control: control,
      name: selectedTemplateFormFieldName,
      render: props => /*#__PURE__*/_jsx(Select, _objectSpread(_objectSpread({}, connectControllerToTextField(props)), {}, {
        disabled: !formState.isValid,
        "data-testid": "".concat(testPrefix, "-dropdown"),
        children: templates.map((_ref2, i) => {
          let {
            dropdownLabel,
            name
          } = _ref2;
          return /*#__PURE__*/_jsx(MenuItem, {
            value: name,
            "data-testid": "".concat(testPrefix, "-dropdown-option-").concat(i),
            children: dropdownLabel
          }, name);
        })
      }))
    }), templates.map(_ref3 => {
      let {
        name
      } = _ref3;
      return /*#__PURE__*/_jsx("div", {
        hidden: selectedTemplateName !== name,
        style: {
          gridColumn: 'span 2'
        },
        ref: el => {
          return refs.current && (refs.current[String(name)] = el);
        },
        children: /*#__PURE__*/_jsx(Controller, {
          control: control,
          name: name,
          rules: messageRules,
          render: props => {
            const _connectControllerToT = connectControllerToTextField(props),
              {
                onChange: _onChange
              } = _connectControllerToT,
              connect = _objectWithoutProperties(_connectControllerToT, _excluded);
            return /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({}, connect), {}, {
              onChange: e => {
                const template = templates.find(_ref4 => {
                  let {
                    name
                  } = _ref4;
                  return name === selectedTemplateName;
                });
                if (template !== null && template !== void 0 && template.readOnly) {
                  onStartEditingReadOnlyTemplate && onStartEditingReadOnlyTemplate(name);
                } else {
                  _onChange(e);
                }
              },
              "data-testid": "".concat(testPrefix, "-").concat(name),
              placeholder: "Your message\u2026",
              multiline: true,
              minRows: 6,
              maxRows: 12
            }));
          }
        })
      }, name);
    })]
  });
}